export const getOneWeekDays = (mouseEnteredDate: Date): number[] => {
    const oneWeekDays = [mouseEnteredDate.getDate()];
    const openedMonthDays = [];

    for (let i = 1; i < 7; i++) {
        oneWeekDays.push(
            new Date(mouseEnteredDate.setDate(mouseEnteredDate.getDate() + 1)).getDate()
        );
    }

    for (let i = 0; i < oneWeekDays.length; i++) {
        if (oneWeekDays[i] > oneWeekDays[i + 1]) {
            openedMonthDays.push(oneWeekDays[i]);
            break;
        }
        openedMonthDays.push(oneWeekDays[i]);
    }

    return openedMonthDays;
};
